export const environment = {
  production: false,
  baseURL: `https://www.currentcos.com/api.svc`,
};
